import React, { useEffect, useRef } from "react";
import Typed from "typed.js";

export default function TypingAnimationComponent({
  texts,
  speed = 50,
  backSpeed = 30,
  backDelay = 2000,
  loopDelay = 1000,
}) {
  const typingRef = useRef(null);

  useEffect(() => {
    const typed = new Typed(typingRef.current, {
      strings: texts,
      typeSpeed: speed,
      backSpeed: backSpeed,
      backDelay: backDelay,
      startDelay: 500,
      loop: true,
      smartBackspace: true,
      fadeOut: false,
    });

    return () => typed.destroy();
  }, [texts, speed, backSpeed, backDelay, loopDelay]);

  return <span ref={typingRef}></span>;
}
